class CartNotification extends HTMLElement {

  constructor() {
    super();

    this.notification =
      document.getElementById(
        'cart-notification'
      );

    this.header =
      document.querySelector(
        'sticky-header'
      );

    this.onBodyClick =
      this.handleBodyClick.bind(this);

    this.isUpdatingCart =
      false;

    this.productCache =
      new Map();


    this.notification.addEventListener(
      'keyup',
      (evt) =>
        evt.code === 'Escape' &&
        this.close()
    );


    this.querySelectorAll(
      'button[type="button"]'
    ).forEach(
      (closeButton) =>

        closeButton.addEventListener(
          'click',
          this.close.bind(this)
        )

    );

  }


  /* =========================================================
     OPEN
     ========================================================= */

open() {

  /*
   * MPM:
   * Wenn der Warenkorb bereits offen ist,
   * keine neue Öffnungsanimation starten.
   */

  if (
    this.notification.classList.contains(
      'active'
    )
  ) {

    this.notification.classList.add(
      'animate'
    );

    return;
  }


  /*
   * Normales erstmaliges Öffnen
   */

  this.notification.classList.add(
    'animate',
    'active'
  );


  this.notification.addEventListener(
    'transitionend',
    () => {

      this.notification.focus();

      trapFocus(
        this.notification
      );

    },
    {
      once: true
    }
  );


  document.body.addEventListener(
    'click',
    this.onBodyClick
  );

}


  /* =========================================================
     CLOSE
     ========================================================= */

  close() {

    this.notification.classList.remove(
      'active'
    );


    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );


    removeTrapFocus(
      this.activeElement
    );

  }


  /* =========================================================
     DAWN RENDER
     ========================================================= */

  renderContents(parsedState) {

    this.cartItemKey =
      parsedState.key;


    this.getSectionsToRender()
      .forEach(
        (section) => {

          const target =
            document.getElementById(
              section.id
            );


          if (
            !target ||
            !parsedState.sections ||
            !parsedState.sections[
              section.id
            ]
          ) {
            return;
          }


          target.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[
                section.id
              ],
              section.selector
            );

        }
      );


    this.updateMPMCartPreview();


    if (this.header) {

      this.header.reveal();

    }


    this.open();

  }


  /* =========================================================
     PRODUKT CACHE
     ========================================================= */

  async getMPMProduct(
    handle
  ) {

    if (!handle) {
      return null;
    }


    if (
      this.productCache.has(
        handle
      )
    ) {

      return this.productCache.get(
        handle
      );

    }


    try {

      const root =
        window.Shopify?.routes?.root
        || '/';


      const response =
        await fetch(
          `${root}products/${encodeURIComponent(handle)}.js`
        );


      if (!response.ok) {
        return null;
      }


      const product =
        await response.json();


      this.productCache.set(
        handle,
        product
      );


      return product;

    } catch (error) {

      return null;

    }

  }


  /* =========================================================
     GELD FORMATIEREN
     ========================================================= */

  formatMPMMoney(
    cents,
    currency
  ) {

    const locale =
      document.documentElement.lang
      || 'de-DE';


    const activeCurrency =
      currency ||
      window.Shopify?.currency?.active ||
      'EUR';


    return new Intl.NumberFormat(
      locale,
      {
        style: 'currency',
        currency: activeCurrency
      }
    ).format(
      cents / 100
    );

  }


  /* =========================================================
     MINDESTBESTELLWERT LIVE
     ========================================================= */

  updateMPMMinimumOrder(
    cart
  ) {

    const minimum =
      Number(
        this.notification.dataset
          .mpmMinimum || 0
      );


    const minimumNotice =
      document.getElementById(
        'mpm-popup-minimum-order'
      );


    const remainingElement =
      document.getElementById(
        'mpm-popup-minimum-remaining'
      );


    const checkoutButton =
      document.querySelector(
        '#cart-notification-form button[name="checkout"]'
      );


    const cartValue =
      Number(
        cart.original_total_price
        || 0
      );


    const reached =
      cartValue >= minimum;


    /* Mindestwert erreicht */
    if (reached) {

      if (minimumNotice) {

        minimumNotice.hidden =
          true;

      }


      if (checkoutButton) {

        checkoutButton.disabled =
          false;


        checkoutButton.removeAttribute(
          'aria-disabled'
        );


        checkoutButton.classList.remove(
          'mpm-checkout-disabled'
        );

      }


      return;

    }


    /* Mindestwert NICHT erreicht */

    const remaining =
      Math.max(
        0,
        minimum - cartValue
      );


    if (
      remainingElement
    ) {

      remainingElement.textContent =
        this.formatMPMMoney(
          remaining,
          cart.currency
        );

    }


    if (
      minimumNotice
    ) {

      minimumNotice.hidden =
        false;

    }


    if (
      checkoutButton
    ) {

      checkoutButton.disabled =
        true;


      checkoutButton.setAttribute(
        'aria-disabled',
        'true'
      );


      checkoutButton.classList.add(
        'mpm-checkout-disabled'
      );

    }

  }

  /* =========================================================
     GRATISVERSAND LIVE
     ========================================================= */

  updateMPMFreeShipping(
    cart
  ) {

    const freeShippingBox =
      document.getElementById(
        'mpm-popup-free-shipping'
      );


    const freeShippingText =
      document.getElementById(
        'mpm-popup-free-shipping-text'
      );


    const freeShippingFill =
      document.getElementById(
        'mpm-popup-free-shipping-fill'
      );


    const freeShippingCurrent =
      document.getElementById(
        'mpm-popup-free-shipping-current'
      );


    if (
      !freeShippingBox ||
      !freeShippingText ||
      !freeShippingFill ||
      !freeShippingCurrent
    ) {
      return;
    }


    const goal =
      Number(
        freeShippingBox.dataset.freeShipping
        || 10000
      );


    const total =
      Number(
        cart.total_price
        || 0
      );


    const percentage =
      Math.max(
        0,
        Math.min(
          100,
          (total / goal) * 100
        )
      );


    freeShippingFill.style.width =
      `${percentage}%`;


    freeShippingCurrent.textContent =
      this.formatMPMMoney(
        total,
        cart.currency
      );


    if (
      total >= goal
    ) {

      freeShippingBox.classList.add(
        'is-unlocked'
      );


      freeShippingText.innerHTML =
        'GRATISVERSAND FREIGESCHALTET! 🚀';


    } else {


      freeShippingBox.classList.remove(
        'is-unlocked'
      );


      const remaining =
        Math.max(
          0,
          goal - total
        );


      freeShippingText.innerHTML =
        `Noch <strong id="mpm-popup-free-shipping-remaining">${this.formatMPMMoney(
          remaining,
          cart.currency
        )}</strong> bis zum GRATISVERSAND`;

    }

  }


  /* =========================================================
     MINI CART
     ========================================================= */

  async updateMPMCartPreview() {

    const itemsContainer =
      document.getElementById(
        'mpm-mini-cart-items'
      );


    const cartCount =
      document.getElementById(
        'mpm-mini-cart-count'
      );


    const summary =
      document.getElementById(
        'mpm-cart-summary'
      );


    const totalElement =
      document.getElementById(
        'mpm-cart-total'
      );

const referenceTotalElement =
  document.getElementById(
    'mpm-cart-reference-total'
  );

    const savingsRow =
      document.getElementById(
        'mpm-cart-total-savings-row'
      );


    const savingsElement =
      document.getElementById(
        'mpm-cart-total-savings'
      );


    if (
      !itemsContainer ||
      !cartCount ||
      !summary ||
      !totalElement ||
      !savingsRow ||
      !savingsElement
    ) {
      return;
    }


    try {

      const root =
        window.Shopify?.routes?.root
        || '/';


      /* CART LADEN */

      const cartResponse =
        await fetch(
          `${root}cart.js`,
          {
            cache: 'no-store',

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!cartResponse.ok) {
        return;
      }


      const cart =
        await cartResponse.json();


      const locale =
        document.documentElement.lang
        || 'de-DE';


      const currency =
        window.Shopify?.currency?.active
        || cart.currency
        || 'EUR';


      const money =
        new Intl.NumberFormat(
          locale,
          {
            style: 'currency',
            currency
          }
        );


      /* PRODUKTDATEN LADEN */

      const productEntries =
        await Promise.all(

          cart.items.map(
            async (item) => {

              const product =
                await this.getMPMProduct(
                  item.handle
                );


              return {
                item,
                product
              };

            }
          )

        );


      const fragment =
        document.createDocumentFragment();


      let totalComparePrice =
        0;


      let totalCurrentPrice =
        0;


      productEntries.forEach(
        ({
          item,
          product
        }) => {


          const variant =
            product?.variants?.find(
              variant =>
                Number(
                  variant.id
                ) ===
                Number(
                  item.variant_id
                )
            );


          const currentLinePrice =
            Number(
              item.final_line_price
              ??
              item.line_price
              ??
              0
            );


          let compareLinePrice =
            0;


          if (
            variant?.compare_at_price &&
            Number(
              variant.compare_at_price
            ) >
            Number(
              item.final_price
            )
          ) {

            compareLinePrice =
              Number(
                variant.compare_at_price
              ) *
              Number(
                item.quantity
              );

          }


          if (
            !compareLinePrice &&
            Number(
              item.original_line_price
            ) >
            currentLinePrice
          ) {

            compareLinePrice =
              Number(
                item.original_line_price
              );

          }


          const saving =
            Math.max(
              0,
              compareLinePrice -
              currentLinePrice
            );


          totalCurrentPrice +=
            currentLinePrice;


          totalComparePrice +=
            compareLinePrice >
            currentLinePrice

              ? compareLinePrice
              : currentLinePrice;


          /* =================================================
             ROW
             ================================================= */

          const row =
            document.createElement(
              'div'
            );


          row.className =
            'mpm-mini-cart-item';


          /* IMAGE */

          const image =
            document.createElement(
              'img'
            );


          image.className =
            'mpm-mini-cart-item__image';


          image.alt =
            item.product_title
            || '';


          image.loading =
            'lazy';


          image.src =
            item.featured_image?.url
            ||
            item.image
            ||
            '';


const imageLink =
  document.createElement(
    'a'
  );

imageLink.className =
  'mpm-mini-cart-item__image-link';

imageLink.href =
  item.url ||
  `/products/${item.handle}`;

imageLink.setAttribute(
  'aria-label',
  item.product_title
);


imageLink.appendChild(
  image
);


row.appendChild(
  imageLink
);

          /* CONTENT */

          const content =
            document.createElement(
              'div'
            );


          content.className =
            'mpm-mini-cart-item__content';


          /* TITLE */

const title =
  document.createElement(
    'a'
  );


title.className =
  'mpm-mini-cart-item__title mpm-mini-cart-item__title-link';


title.href =
  item.url ||
  `/products/${item.handle}`;


title.textContent =
  item.product_title;


content.appendChild(
  title
);

          /* =================================================
             META
             ================================================= */

          const meta =
            document.createElement(
              'div'
            );


          meta.className =
            'mpm-mini-cart-item__meta';


          const variantText =
            document.createElement(
              'div'
            );


          variantText.className =
            'mpm-mini-cart-item__variant';


          if (
            item.variant_title &&
            item.variant_title !==
            'Default Title'
          ) {

            variantText.textContent =
              item.variant_title;

          } else {

            variantText.textContent =
              'Menge';

          }


          meta.appendChild(
            variantText
          );


          /* =================================================
             QUANTITY CONTROL
             ================================================= */

          const quantityControl =
            document.createElement(
              'div'
            );


          quantityControl.className =
            'mpm-mini-cart-item__quantity-control';


          /* MINUS */

          const minusButton =
            document.createElement(
              'button'
            );


          minusButton.type =
            'button';


          minusButton.className =
            'mpm-mini-cart-item__quantity-button';


          minusButton.textContent =
            '−';


          minusButton.setAttribute(
            'aria-label',
            `${item.product_title} Menge verringern`
          );


          minusButton.addEventListener(
            'click',
            () => {

              this.changeMPMCartQuantity(
                item.key,
                Math.max(
                  0,
                  item.quantity - 1
                )
              );

            }
          );


          /* INPUT */

          const quantityInput =
            document.createElement(
              'input'
            );


          quantityInput.type =
            'number';


          quantityInput.className =
            'mpm-mini-cart-item__quantity-input';


          quantityInput.value =
            item.quantity;


          quantityInput.min =
            '1';


          quantityInput.step =
            '1';


          quantityInput.inputMode =
            'numeric';


          quantityInput.setAttribute(
            'pattern',
            '[0-9]*'
          );


          quantityInput.setAttribute(
            'aria-label',
            `${item.product_title} Menge`
          );


          quantityInput.addEventListener(
            'keydown',
            (event) => {

              if (
                event.key ===
                'Enter'
              ) {

                event.preventDefault();

                quantityInput.blur();

              }

            }
          );


          quantityInput.addEventListener(
            'change',
            () => {

              let newQuantity =
                parseInt(
                  quantityInput.value,
                  10
                );


              if (
                !Number.isFinite(
                  newQuantity
                ) ||
                newQuantity < 1
              ) {

                quantityInput.value =
                  item.quantity;

                return;

              }


              if (
                newQuantity ===
                item.quantity
              ) {
                return;
              }


              this.changeMPMCartQuantity(
                item.key,
                newQuantity
              );

            }
          );


          /* PLUS */

          const plusButton =
            document.createElement(
              'button'
            );


          plusButton.type =
            'button';


          plusButton.className =
            'mpm-mini-cart-item__quantity-button';


          plusButton.textContent =
            '+';


          plusButton.setAttribute(
            'aria-label',
            `${item.product_title} Menge erhöhen`
          );


          plusButton.addEventListener(
            'click',
            () => {

              this.changeMPMCartQuantity(
                item.key,
                item.quantity + 1
              );

            }
          );


          quantityControl.appendChild(
            minusButton
          );


          quantityControl.appendChild(
            quantityInput
          );


          quantityControl.appendChild(
            plusButton
          );


          meta.appendChild(
            quantityControl
          );


          content.appendChild(
            meta
          );


          /* =================================================
             PREISE
             ================================================= */

          const prices =
            document.createElement(
              'div'
            );


          prices.className =
            'mpm-mini-cart-item__prices';


          if (
            compareLinePrice >
            currentLinePrice
          ) {

            const oldPrice =
              document.createElement(
                'span'
              );


            oldPrice.className =
              'mpm-mini-cart-item__old-price';


            oldPrice.textContent =
              money.format(
                compareLinePrice / 100
              );


            prices.appendChild(
              oldPrice
            );

          }


          const currentPrice =
            document.createElement(
              'span'
            );


          currentPrice.className =
            'mpm-mini-cart-item__current-price';


          currentPrice.textContent =
            money.format(
              currentLinePrice / 100
            );


          prices.appendChild(
            currentPrice
          );


          content.appendChild(
            prices
          );


          row.appendChild(
            content
          );


          fragment.appendChild(
            row
          );

        }
      );


      /* =====================================================
         ALLES AUF EINMAL ERSETZEN
         ===================================================== */

      itemsContainer.replaceChildren(
        fragment
      );


      /* ANZAHL */

      cartCount.textContent =
        `${cart.item_count} Artikel`;


      /* SUMME */

      totalElement.textContent =
        money.format(
          Number(
            cart.total_price || 0
          ) / 100
        );


      /* GESAMTERSPARNIS */

      const totalSavings =
        Math.max(
          0,
          totalComparePrice -
          totalCurrentPrice
        );
/* ALTER GESAMTPREIS */

if (
  totalSavings > 0 &&
  totalComparePrice > totalCurrentPrice
) {

  referenceTotalElement.textContent =
    money.format(
      totalComparePrice / 100
    );

  referenceTotalElement.hidden =
    false;

} else {

  referenceTotalElement.textContent =
    '';

  referenceTotalElement.hidden =
    true;

}

      if (
        totalSavings > 0
      ) {

        savingsElement.textContent =
          money.format(
            totalSavings / 100
          );


        savingsRow.hidden =
          false;

      } else {

        savingsElement.textContent =
          '';


        savingsRow.hidden =
          true;

      }


      summary.hidden =
        false;


      /* Mindestbestellwert live */

      this.updateMPMMinimumOrder(
        cart
      );


      /* Gratisversand live */

      this.updateMPMFreeShipping(
        cart
      );


      this.updateMPMCartBubble(
        cart
      );


      this.updateMPMCartButton(
        cart
      );


    } catch (error) {

      console.warn(
        'MPM SHOP: Warenkorb-Vorschau konnte nicht geladen werden.',
        error
      );

    }

  }


  /* =========================================================
     MENGE ÄNDERN
     ========================================================= */

  async changeMPMCartQuantity(
    key,
    quantity
  ) {

    if (
      this.isUpdatingCart
    ) {
      return;
    }


    this.isUpdatingCart =
      true;


    const buttons =
      this.querySelectorAll(
        '.mpm-mini-cart-item__quantity-button'
      );


    const inputs =
      this.querySelectorAll(
        '.mpm-mini-cart-item__quantity-input'
      );


    buttons.forEach(
      button =>
        button.disabled = true
    );


    inputs.forEach(
      input =>
        input.disabled = true
    );


    try {

      const root =
        window.Shopify?.routes?.root
        || '/';


      const response =
        await fetch(
          `${root}cart/change.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                id: key,
                quantity: quantity
              })
          }
        );


      if (!response.ok) {

        throw new Error(
          'Cart update failed'
        );

      }


      const cart =
        await response.json();


      if (
        !cart.items ||
        cart.items.length === 0
      ) {

        this.close();

        window.location.reload();

        return;

      }


      await this.updateMPMCartPreview();


    } catch (error) {

      console.warn(
        'MPM SHOP: Menge konnte nicht geändert werden.',
        error
      );


    } finally {

      this.isUpdatingCart =
        false;

    }

  }


  /* =========================================================
     CART ICON
     ========================================================= */

  updateMPMCartBubble(
    cart
  ) {

    const bubble =
      document.getElementById(
        'cart-icon-bubble'
      );


    if (!bubble) {
      return;
    }


    const countBubble =
      bubble.querySelector(
        '.cart-count-bubble'
      );


    if (
      countBubble
    ) {

      const visibleCount =
        countBubble.querySelector(
          'span[aria-hidden="true"]'
        );


      const hiddenCount =
        countBubble.querySelector(
          '.visually-hidden'
        );


      if (
        visibleCount
      ) {

        visibleCount.textContent =
          cart.item_count;

      }


      if (
        hiddenCount
      ) {

        hiddenCount.textContent =
          `${cart.item_count} Artikel`;

      }

    }

  }


  /* =========================================================
     WARENKORB BUTTON TEXT
     ========================================================= */

  updateMPMCartButton(
    cart
  ) {

    const cartButton =
      document.getElementById(
        'cart-notification-button'
      );


    if (!cartButton) {
      return;
    }


    cartButton.textContent =
      `Warenkorb ansehen (${cart.item_count})`;

  }


  /* =========================================================
     DAWN STANDARD
     ========================================================= */

  getSectionsToRender() {

    return [

      {
        id:
          'cart-notification-product',

        selector:
          `[id="cart-notification-product-${this.cartItemKey}"]`
      },

      {
        id:
          'cart-notification-button'
      },

      {
        id:
          'cart-icon-bubble'
      }

    ];

  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    const parsedHTML =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const element =
      parsedHTML.querySelector(
        selector
      );


    return element
      ? element.innerHTML
      : '';

  }


  handleBodyClick(evt) {

  const target = evt.target;


  /*
   * MPM:
   * Klick auf einen echten IN-DEN-WARENKORB Button
   * darf das bereits offene Popup NICHT schließen.
   *
   * Wichtig:
   * Nur ganz gezielte Button-Selektoren,
   * keine ganzen product-form / form Container.
   */

  const addButton =
    target.closest(
      'button[name="add"], ' +
      '.product-form__submit, ' +
      '.quick-add__submit'
    );


  if (addButton) {
    return;
  }


  /*
   * Alles andere außerhalb schließt weiterhin normal.
   */

  if (
    target !== this.notification &&
    !target.closest('cart-notification')
  ) {

    const disclosure =
      target.closest(
        'details-disclosure, header-menu'
      );


    this.activeElement =
      disclosure
        ? disclosure.querySelector('summary')
        : null;


    this.close();

  }

  }


  setActiveElement(
    element
  ) {

    this.activeElement =
      element;

  }

}


customElements.define(
  'cart-notification',
  CartNotification
);
/* =========================================================
   MPM – WARENKORB ICON
   1. Klick  = Mini-Cart öffnen
   2. Klick  = Warenkorbseite öffnen
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  const cartIcon =
    document.querySelector('#cart-icon-bubble');

  const cartNotification =
    document.querySelector('cart-notification');

  const notification =
    document.getElementById('cart-notification');

  if (
    !cartIcon ||
    !cartNotification ||
    !notification
  ) {
    return;
  }


  cartIcon.addEventListener(
    'click',
    async function (event) {

      /*
       * Mini-Cart ist bereits geöffnet:
       * → zur vollständigen Warenkorbseite
       */

      if (
        notification.classList.contains('active')
      ) {

        event.preventDefault();
        event.stopPropagation();

        const root =
          window.Shopify?.routes?.root || '/';

        window.location.href =
          `${root}cart`;

        return;
      }


      /*
       * Mini-Cart ist geschlossen:
       * → normale MPM Warenkorb-Vorschau öffnen
       */

      event.preventDefault();
      event.stopPropagation();

      try {

        await cartNotification.updateMPMCartPreview();

      } catch (error) {

        console.warn(
          'MPM SHOP: Warenkorb konnte vor dem Öffnen nicht aktualisiert werden.',
          error
        );

      }


      cartNotification.setActiveElement(
        cartIcon
      );

      cartNotification.open();

    }
  );

});
